import { Context, ContextBi, contextToBiEvent, getChatbotView } from '@wix/wix-chatbot-common/browser';

import { TRootState } from '../../common/reducers';
import { selectLoadPageUrl } from '../../common/selectors/meta';
import { selectWidgetSessionId } from '../../common/selectors/widgetSession';
import { widgetSDK } from '../../sdk/widgetSDK';
import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';

const userId = renderModel.getUserId();

const getContext = async (loadPageUrl?: string): Promise<Context | undefined> => {
  try {
    const context = await widgetSDK.getContext(loadPageUrl);

    if (!context || !Object.keys(context).length) {
      const error = new Error(`Context is empty`);
      logger.error({
        error,
        message: 'Context is empty',
        callParams: { userId },
      });
      return;
    }

    return context;
  } catch (error) {
    logger.error({
      message: 'fail to get Context',
      error,
    });
  }
};

export const getRuntimeDataForBi = async (
  state: TRootState,
): Promise<{
  userPriorityClass: string;
  sessionId: string | undefined;
  metaSiteId: string | undefined;
  contextBi: ContextBi | undefined;
  placement: string | undefined;
}> => {
  const loadPageUrl = selectLoadPageUrl(state);
  return Promise.all([getContext(loadPageUrl), widgetSDK.getWidgetPlacement()])
    .then(([context, placement]) => {
      const contextBi = contextToBiEvent(context as Context);

      if (loadPageUrl && !contextBi.chatbot_view) {
        contextBi.chatbot_view = getChatbotView({ parentUrl: loadPageUrl });
      }

      return {
        userPriorityClass: context?.careProfile?.userPriorityClass || '',
        sessionId: selectWidgetSessionId(state),
        metaSiteId: context?.metaSiteId,
        contextBi,
        placement,
      };
    })
    .catch((error) => {
      logger.error({
        message: 'Fail to get SDK data for bi event',
        error,
      });
      return {
        userPriorityClass: '',
        sessionId: undefined,
        metaSiteId: undefined,
        contextBi: undefined,
        placement: undefined,
      };
    });
};

export const countWords = (stringToBreak: string) => {
  const words = stringToBreak.match(/[^\s]+/g);
  return words ? words.length : 0;
};

export const cleanGeneratedAnswer = (generatedAnswer: string) => {
  const allowedTags = generatedAnswer.replace(/<\/?(?!a\b)[^>]+>/g, '');
  const cleanedText = allowedTags.replace(/\*\*/g, '');
  return cleanedText;
};
